import { render } from "./limit-exception-settings.vue?vue&type=template&id=2b8fe207&ts=true"
import script from "./limit-exception-settings.ts?vue&type=script&lang=ts"
export * from "./limit-exception-settings.ts?vue&type=script&lang=ts"

import "./limit-exception-settings.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__